import React from 'react';
import Icon from 'antd/lib/icon';
import Button from 'antd/lib/button';
import { Link } from 'react-router-dom';

const footerST = {
   position:'absolute',
   bottom:0,
   width:'100%',
   height:'4em',  /* Height of the footer */
   backgroundColor: '#d4002a',
   color: 'white',
   boxShadow: '0em -0.2em 2em #888888'
};

const ST_body = {
    float: 'left',
    marginTop: 20,
    marginLeft: 20
};
const ST_support = {
    textAlign: 'right',
    padding: 20,
    color: '#FFF',
    fontSize: '0.9em'
};

const FooterSolid = (props) => (
    <div style={footerST}>
        <p style={ST_support} >CX Systems Powered by MRM Support</p>
    </div>
);

export default FooterSolid;



// WEBPACK FOOTER //
// ./src/components/UI/Footer.jsx